/**
 *
 *
 * Author:   shann
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/3/16      1.0     First version
 *
 * Copyright  2021/3/16 , all rights reserved. Essa.cn
 * */
import React, { Component } from "react";
import {
    Form,
    Input,
    Select,
    Table,
    Space,
    Button,
    Modal,
    message,
    Row,
    Col,
    Checkbox,
    Radio,
    Popover,
} from "antd";
import {
    PlusSquareOutlined,
    ExclamationCircleOutlined,
} from "@ant-design/icons";
//  import md5 from 'blueimp-md5'
import { station, list, edit, add, status, postUserMenus, } from "../../api/user";
import Lang from "../../components/Lang/Lang";
import "./index.css";
import Cookie from "../../utils/cookie";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";
import AuthorityManage from "./component/AuthorityManage/AuthorityManage";
import IconFont from "@components/IconFont/index";
import Locale from '@/utils/locale'
const { confirm } = Modal;
const { Column } = Table;
const { Search } = Input;
let locale = Locale.current();

export default class Index extends Component {
    state = {
        statusOption: [
            {
                value: "0",
                label: Lang({ id: "TingYong", children: "停用" }),
            },
            {
                value: "1",
                label: Lang({ id: "QiYong", children: "启用" }),
            },
        ],
        loading: false,
        total: 0,
        tableData: [],
        isEdit: false,
        currentRowData: {},
        listQuery: {
            pageIndex: 1,
            pageSize: 50,
            contactWay: "",
            status: "1",
        },
        visible: false,
        confirmLoading: false,
        id: "",
        stationOption: [],
        resetVisible: false,
        permissionsVisible: false,
        menusList: [],
    };
    formRef = React.createRef();
    resetPasswordRef = React.createRef();
    permissionForm = React.createRef();
    getStation() {
        const _this = this;
        station({
            code: "mg_foreign_user_station",
        })
            .then(function (response) {
                if (response.data.success && response.data.valid) {
                    _this.setState({
                        stationOption: response.data.models,
                    });
                } else {
                    message.info(response.data.message);
                }
            })
            .catch((error) => {
                message.error(error.message);
            });
    }

    paginationChange = (pageIndex, pageSize) => {
        this.setState(
            {
                listQuery: {
                    ...this.state.listQuery,
                    pageIndex,
                    pageSize,
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    changeContactWay = ({ target: { value } }) => {
        value = value.trim();
        this.setState({
            listQuery: {
                ...this.state.listQuery,
                contactWay: value ? value : "",
            },
        });
    };

    changeStatus = (v) => {
        this.setState(
            {
                listQuery: {
                    ...this.state.listQuery,
                    status: v,
                    pageIndex: 1,
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    fetchData = () => {
        const _this = this;
        this.setState(
            {
                loading: true,
            },
            () => {
                const { listQuery } = this.state;
                list({
                    contactWay: listQuery.contactWay,
                    status: listQuery.status,
                    pagingQuery: {
                        pageIndex: listQuery.pageIndex,
                        pageSize: listQuery.pageSize,
                    },
                })
                    .then(function (response) {
                        _this.setState({
                            tableData: response.data.models,
                            total:
                                response.data.paging &&
                                response.data.paging.total
                                    ? response.data.paging.total
                                    : 0,
                        });
                        _this.setState({ loading: false });
                    })
                    .catch((error) => {
                        message.error(error.message);
                        _this.setState({ loading: false });
                    });
            }
        );
    };

    //新增或编辑
    handleOk = () => {
        const _this = this;
        const { validateFields } = this.formRef.current;
        const { isEdit, id, currentRowData } = this.state;
        let { countryCode } = Cookie.getJSON("fmg.extra") || {};
        validateFields()
            .then((values) => {
                const { account, mobile, name, password, positionId, menuIds } = values;
                this.setState(
                    {
                        confirmLoading: true,
                    },
                    () => {
                        if (isEdit) {
                            edit({
                                //修改
                                account: currentRowData.account,
                                id,
                                mobile,
                                name,
                                positionId,
                            })
                                .then(function (response) {
                                    if (
                                        response.data.success &&
                                        response.data.valid
                                    ) {
                                        _this.fetchData();
                                    } else {
                                        message.info(response.data.message);
                                    }
                                    _this.setState({
                                        confirmLoading: false,
                                        visible: false,
                                    });
                                })
                                .catch((error) => {
                                    message.error(error.message);
                                    _this.setState({
                                        confirmLoading: false,
                                    });
                                });
                        } else {
                            add({
                                //新增
                                account,
                                id: "",
                                mobile,
                                name,
                                password,
                                positionId,
                                countryCode: countryCode,
                                menuIds,
                            })
                                .then(function (response) {
                                    if (
                                        response.data.success &&
                                        response.data.valid
                                    ) {
                                        _this.fetchData();
                                    } else {
                                        message.info(response.data.message);
                                    }
                                    _this.setState({
                                        confirmLoading: false,
                                        visible: false,
                                    });
                                })
                                .catch((error) => {
                                    message.error(error.message);
                                    _this.setState({
                                        confirmLoading: false,
                                    });
                                });
                        }
                    }
                );
            })
            .catch((errorInfo) => {});
    };

    handleCancel = () => {
        this.setState({
            visible: false,
            resetVisible: false,
        });
    };

    handleResetOk = () => {
        const _this = this;
        const { validateFields } = this.resetPasswordRef.current;
        const { id, currentRowData } = this.state;
        validateFields()
            .then((values) => {
                const { password } = values;
                this.setState(
                    {
                        confirmLoading: true,
                    },
                    () => {
                        edit({
                            //修改
                            account: currentRowData.account,
                            id,
                            mobile: currentRowData.mobile,
                            name: currentRowData.name,
                            positionId: currentRowData.positionId,
                            password,
                        })
                            .then(function (response) {
                                if (
                                    response.data.success &&
                                    response.data.valid
                                ) {
                                    _this.fetchData();
                                } else {
                                    message.info(response.data.message);
                                }
                                _this.setState({
                                    confirmLoading: false,
                                    resetVisible: false,
                                });
                            })
                            .catch((error) => {
                                message.error(error.message);
                                _this.setState({
                                    confirmLoading: false,
                                });
                            });
                    }
                );
            })
            .catch((err) => {});
    };

    blockUp = (row) => {
        const _this = this;
        confirm({
            title: <Lang id="ShiFouTingYongGaiZhangHao">是否停用该账号?</Lang>,
            icon: <ExclamationCircleOutlined />,
            onOk() {
                return new Promise((resolve, reject) => {
                    status({
                        ...row,
                        status: 0,
                    })
                        .then((response) => {
                            if (response.data.success && response.data.valid) {
                                _this.fetchData();
                            } else {
                                message.info(response.data.message);
                            }
                            resolve();
                        })
                        .catch((error) => {
                            reject(error);
                        });
                }).catch((err) => message.error(err));
            },
        });
    };

    startUsing = (row) => {
        const _this = this;
        confirm({
            title: <Lang id="ShiFouQiYongGaiZhangHao">是否启用该账号?</Lang>,
            icon: <ExclamationCircleOutlined />,
            onOk() {
                return new Promise((resolve, reject) => {
                    status({
                        ...row,
                        status: 1,
                    })
                        .then((response) => {
                            if (response.data.success && response.data.valid) {
                                _this.fetchData();
                            } else {
                                message.info(response.data.message);
                            }
                            resolve();
                        })
                        .catch((error) => {
                            reject(error);
                        });
                }).catch((err) => message.error(err));
            },
        });
    };

    handleEdit = (row) => {
        this.setState(
            {
                currentRowData: Object.assign({}, row),
                visible: true,
                isEdit: true,
                id: row.id,
            },
            () => {
                this.formRef.current.setFieldsValue({
                    ...this.state.currentRowData,
                });
            }
        );
    };

    showVisible = () => {
        this.setState(
            {
                visible: true,
                isEdit: false,
            },
            () => {
                this.formRef.current.resetFields();
            }
        );
    };

    search = (value) => {
        this.setState(
            {
                listQuery: {
                    ...this.state.listQuery,
                    pageIndex: 1,
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    showResetPassword(row) {
        this.setState(
            {
                currentRowData: Object.assign({}, row),
                resetVisible: true,
                id: row.id,
            },
            () => {
                this.resetPasswordRef.current.resetFields();
                this.resetPasswordRef.current.setFieldsValue({
                    account: this.state.currentRowData.account,
                });
            }
        );
    }


    componentDidMount() {
        this.fetchData();
        this.getStation();
    }

    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
    };

    render() {
        const {
            tableData,
            total,
            loading,
            visible,
            confirmLoading,
            statusOption,
            listQuery,
            isEdit,
            stationOption,
            resetVisible,
        } = this.state;
        const layout = {
            labelCol: {
                sm: { span: 5 },
            },
            wrapperCol: {
                sm: { span: 19 },
            },
            labelAlign: "left",
        };
        return (
            <div>
                <CommonBreadcrumb list={[{name:__getServerLanguage('YuanGongZhangHaoGuanLi')}]}></CommonBreadcrumb>
                <div className="user-box">
                    <div className="title">
                    <span className="title-text fw_700 font-18">
                        {<Lang id="YuanGongZhangHaoGuanLi">账号管理</Lang>}
                    </span>
                        <span onClick={this.showVisible} className="title-add">
                        <PlusSquareOutlined className="add-icon" />
                            {<Lang id="XinZengYuanGong">新增员工</Lang>}
                    </span>
                    </div>
                    <div className="content-box">
                        <Form layout="inline" initialValues={listQuery}>
                            <Row style={{ width: "100%" }}>
                                <Col span={7}>
                                    <Form.Item label="">
                                        <Search
                                            placeholder={
                                                Lang({
                                                    id: "XingMing",
                                                    default: "姓名",
                                                }) +
                                                "/" +
                                                Lang({
                                                    id: "DianHua",
                                                    default: "电话",
                                                })
                                            }
                                            style={{ width: "100%" }}
                                            loading={loading}
                                            onChange={this.changeContactWay}
                                            onSearch={this.search}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={7}>
                                    <Form.Item label="" name={'status'}>
                                        <Select
                                            style={{ width: "100%" }}
                                            placeholder={
                                                <Lang id="QingXuanZeZhuangTai">
                                                    请选择状态
                                                </Lang>
                                            }
                                            onChange={this.changeStatus}
                                            allowClear
                                        >
                                            {statusOption.map((item, index) => {
                                                return (
                                                    <Select.Option
                                                        key={index}
                                                        value={item.value}
                                                    >
                                                        {item.label}
                                                    </Select.Option>
                                                );
                                            })}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                        <Table
                            rowKey="id"
                            className="table-box"
                            loading={loading}
                            dataSource={tableData}
                            pagination={{
                                showQuickJumper: true,
                                onChange: this.paginationChange,
                                total: total,
                                current: listQuery.pageIndex,
                                defaultPageSize: listQuery.pageSize,
                                showSizeChanger: true,
                                showTotal: (total) => `Total ${total} items`,
                                pageSizeOptions: [50, 100],
                            }}
                        >
                            <Column
                                className="columnWidth"
                                title={<Lang id="XingMing">姓名</Lang>}
                                dataIndex="name"
                            />
                            <Column
                                className="columnWidth"
                                title={<Lang id="DengLuMing">登录名</Lang>}
                                dataIndex="account"
                            />
                            <Column
                                className="columnWidth"
                                title={<Lang id="LianXiDianHua">联系电话</Lang>}
                                dataIndex="mobile"
                            />
                            <Column
                                className="columnWidth"
                                title={<Lang id="GangWei">岗位</Lang>}
                                dataIndex="positionName"
                            />
                            <Column
                                className="columnWidth"
                                title={<Lang id="YiGenJinKeHu">已跟进客户</Lang>}
                                dataIndex="followerNum"
                            />
                            <Column
                                className="columnWidth"
                                title={<Lang id="ZhangHaoZhuangTai">账号状态</Lang>}
                                dataIndex="statusDesc"
                            />
                            <Column
                                width={150}
                                className="actionWidth"
                                title={<Lang id="CaoZuo">操作</Lang>}
                                render={(text, row) => (
                                    <Space>
                                        {/*修改*/}
                                        <Popover content={Lang({id: 'BianJiKeHuXinXi'})}>
                                            <a className="link" onClick={() => {
                                                this.handleEdit(row);
                                            }}>
                                                <IconFont
                                                    type="icon-xiugai-1"
                                                    className="hover-hide"
                                                    style={{ fontSize: "32px" }}
                                                ></IconFont>
                                                <IconFont
                                                    type="icon-xiugai-2"
                                                    className="hover-show"
                                                    style={{ fontSize: "32px" }}
                                                ></IconFont>
                                            </a>
                                        </Popover>

                                        {/*重置密码*/}
                                        <Popover content={Lang({id: 'ChongZhiMiMa'})}>
                                            <a className="link" onClick={() => {
                                                this.showResetPassword(row);
                                            }}>
                                                <IconFont
                                                    type="icon-zhongzhimima-1"
                                                    className="hover-hide"
                                                    style={{ fontSize: "32px" }}
                                                ></IconFont>
                                                <IconFont
                                                    type="icon-zhongzhimima-2"
                                                    className="hover-show"
                                                    style={{ fontSize: "32px" }}
                                                ></IconFont>
                                            </a>
                                        </Popover>

                                        {/*启用禁用*/}
                                            {row.status === 0 ? (
                                                <Popover content={Lang({id: 'QiYong'})}>
                                                    <a className="link" onClick={() => {
                                                        this.startUsing(row);
                                                    }}>
                                                        <IconFont
                                                            type="icon-qiyong"
                                                            className="hover-hide"
                                                            style={{ fontSize: "32px" }}
                                                        ></IconFont>
                                                        <IconFont
                                                            type="icon-qiyong-1"
                                                            className="hover-show"
                                                            style={{ fontSize: "32px" }}
                                                        ></IconFont>
                                                    </a>
                                                </Popover>

                                            ) : (
                                                <Popover content={Lang({id: 'TingYong'})}>
                                                    <a className="link" onClick={() => {
                                                        this.blockUp(row);
                                                    }}>
                                                        <IconFont
                                                            type="icon-tingyong"
                                                            className="hover-hide"
                                                            style={{ fontSize: "32px" }}
                                                        ></IconFont>
                                                        <IconFont
                                                            type="icon-tingyong-1"
                                                            className="hover-show"
                                                            style={{ fontSize: "32px" }}
                                                        ></IconFont>
                                                    </a>
                                                </Popover>
                                            )}
                                        <AuthorityManage user={row} callBack={()=>this.fetchData()}/>
                                    </Space>
                                )}
                            />
                        </Table>
                    </div>
                    {/* 新增或修改弹窗 */}
                    <Modal
                        title={
                            isEdit ? (
                                <Lang id="BianJiKeHuXinXi">编辑员工信息</Lang>
                            ) : (
                                <Lang id="XinZengKeHuXinXi">新增员工信息</Lang>
                            )
                        }
                        open={visible}
                        onOk={this.handleOk}
                        confirmLoading={confirmLoading}
                        onCancel={this.handleCancel}
                        className="user-edit-modal"
                    >
                        <Form
                            ref={this.formRef}
                            {...layout}
                            name="basic"
                            labelCol={{ span: locale==='zh'?6:9 }}
                        >
                            <Form.Item
                                label={<Lang id="XingMing">姓名</Lang>}
                                name="name"
                                rules={[
                                    {
                                        required: true,
                                        message: (
                                            <Lang id="QingShuRuYuanGongXingMing">
                                                请输入员工姓名
                                            </Lang>
                                        ),
                                    },
                                ]}
                            >
                                <Input
                                    placeholder={Lang({
                                        id: "QingShuRuYuanGongXingMing",
                                        children: "请输入员工姓名",
                                    })}
                                />
                            </Form.Item>
                            {!isEdit && (
                                <Form.Item
                                    label={
                                        <Lang id="DengLuZhangHao">登录账号</Lang>
                                    }
                                    name="account"
                                    rules={[
                                        {
                                            required: true,
                                            message: (
                                                <Lang id="QingSheZhiYuanGongDengLuZhangHao">
                                                    请设置员工登录账号
                                                </Lang>
                                            ),
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder={Lang({
                                            id: "QingSheZhiYuanGongDengLuZhangHao",
                                            children: "请设置员工登录账号",
                                        })}
                                    />
                                </Form.Item>
                            )}

                            {!isEdit && (
                                <Form.Item
                                    label={<Lang id="DengLuMiMa">登录密码</Lang>}
                                    name="password"
                                    rules={[
                                        {
                                            required: true,
                                            message: Lang({
                                                id: "QingSheZhiYuanGongDengLuMiMa",
                                                children: "请设置员工登录密码",
                                            }),
                                        },
                                    ]}
                                >
                                    <Input.Password
                                        placeholder={Lang({
                                            id: "QingSheZhiYuanGongDengLuMiMa",
                                            children: "请设置员工登录密码",
                                        })}
                                    />
                                </Form.Item>
                            )}

                            <Form.Item
                                label={<Lang id="GangWei">岗位</Lang>}
                                name="positionId"
                            >
                                <Select
                                    placeholder={Lang({
                                        id: "QingXuanZeGangWei",
                                        children: "请选择岗位",
                                    })}
                                >
                                    {stationOption.map((item) => {
                                        return (
                                            <Select.Option
                                                value={item.id}
                                                key={item.id}
                                            >
                                                {item.name}
                                            </Select.Option>
                                        );
                                    })}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label={<Lang id="LianXiDianHua">联系电话</Lang>}
                                name="mobile"
                                rules={[
                                    {
                                        required: false,
                                        pattern: new RegExp(/^[1-9]\d*$/, "g"),
                                        message: Lang({
                                            id: "QingShuRuZhengQueDeLianXiDianHua",
                                            children: "请输入正确的联系电话",
                                        }),
                                    },
                                ]}
                            >
                                <Input
                                    placeholder={Lang({
                                        id: "QingSheZhiYuanGongLianXiDianHua",
                                        children: "请设置员工联系电话",
                                    })}
                                />
                            </Form.Item>
                        </Form>
                    </Modal>
                    {/* 重置密码弹窗 */}
                    <Modal
                        title={Lang({ id: "ChongZhiMiMa" })}
                        open={resetVisible}
                        onOk={this.handleResetOk}
                        confirmLoading={confirmLoading}
                        onCancel={this.handleCancel}
                    >
                        <Form
                            {...layout}
                            name="resetForm"
                            ref={this.resetPasswordRef}
                        >
                            <Form.Item
                                label={<Lang id="ZhangHuZhongXin">账号</Lang>}
                                name="account"
                            >
                                <Input
                                    disabled
                                    placeholder={Lang({
                                        id: "QingSheZhiYuanGongDengLuZhangHao",
                                        children: "请设置员工登录账号",
                                    })}
                                />
                            </Form.Item>

                            <Form.Item
                                label={<Lang id="XinMiMa">新密码</Lang>}
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        message: Lang({
                                            id: "QingShuRuYuanGongZhangHuXinMiMa",
                                            children: "请输入员工账户新密码",
                                        }),
                                    },
                                ]}
                            >
                                <Input.Password
                                    placeholder={Lang({
                                        id: "QingSheZhiYuanGongDengLuMiMa",
                                        children: "请输入员工账户新密码",
                                    })}
                                />
                            </Form.Item>
                        </Form>
                    </Modal>
                </div>
            </div>
        );
    }
}
